import { ListItem } from '@mui/material';
import { ReactNode } from 'react';
import { LinkProps } from 'react-router-dom';
import { StyledItemButton, StyledItemText, StyledLink } from './status.styles';

interface IPopoverItemProps {
  onClick?: LinkProps['onClick'];
  to: string;
  text: string;
  icon: ReactNode;
}

const PopoverItem = ({ onClick, to, icon, text }: IPopoverItemProps) => {
  return (
    <ListItem disablePadding>
      <StyledLink to={to} onClick={onClick}>
        <StyledItemButton disableRipple>
          {icon}
          <StyledItemText primary={text} />
        </StyledItemButton>
      </StyledLink>
    </ListItem>
  );
};

export default PopoverItem;
